<template>
  <div v-if="organization">
    <payment-method-form :organization="organization"
                         payment-methods-url="/customers/payment_methods"
                         @success="$emit('saved')"
                         @cancel="$emit('cancel')"/>
  </div>
</template>

<script>

import PaymentMethodForm from "../PaymentMethods/PaymentMethodForm.vue";
import {OrganizationsApi} from "../../Api/OrganizationsApi.js";

export default {
  components: {PaymentMethodForm},

  data() {
    return {
      organization: null
    }
  },

  async mounted() {
    this.organization = await OrganizationsApi.getOrganization()
  }
}
</script>